import { get, reduce } from 'lodash'

const sumUpModifiers = (modifiers) =>
  reduce(
    modifiers,
    (acc, modifierItem) => {
      const priceInCents = get(modifierItem, 'defaultPriceInCents', 0)

      if (modifierItem.refund) {
        return acc
      }

      return acc + priceInCents
    },
    0,
  )

export default sumUpModifiers
